"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corbola": {
    "55d48e87": [{
      "hkey": "1af23a7d",
      "slug": "corbola",
      "name": "Corbola",
      "primary": true,
      "skipSearch": false
    }],
    "garzara": [{
      "hkey": "1af23a7d",
      "slug": "corbola",
      "name": "Corbola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6cb4db8e": [{
      "hkey": "1af23a7d",
      "slug": "corbola",
      "name": "Corbola",
      "primary": true,
      "skipSearch": false
    }],
    "sabbioni": [{
      "hkey": "1af23a7d",
      "slug": "corbola",
      "name": "Corbola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;